import { HugerteEditor } from 'components/FormControl';
import PropTypes from 'prop-types';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

export default function ResearchContributions({ control, errors, disabled, watch, researchTypes }) {
  // #region Data
  const { t } = useTranslation();

  const researchTypesId = watch('general.researchTypesId');
  const researchTypeCode = useMemo(
    () => researchTypes?.find((item) => item?.id === researchTypesId)?.code,
    [researchTypes, researchTypesId]
  );
  console.log({ researchTypeCode });
  // #endregion

  return (
    <div className="mt-3">
      <h4>{t('projectProposal.researchResult.researchContributions.label')}</h4>
      <div className="mt-3">
        <h4>
          {t('projectProposal.researchResult.researchContributions.contributionAndResolution')}
        </h4>
        <p className="font-italic">
          {t('projectProposal.researchResult.researchContributions.contributionAndResolutionNote')}
        </p>
        <HugerteEditor
          name="researchResult.knowledgeContributionLevel"
          control={control}
          errors={errors}
          readOnly={disabled}
        />
      </div>

      <div className="mt-3">
        <h4>{t('projectProposal.researchResult.researchContributions.practicalImpact')}</h4>
        <p className="font-italic">
          {t('projectProposal.researchResult.researchContributions.practicalImpactNote')}
        </p>
        <HugerteEditor
          name="researchResult.practicalPolicyImpact"
          control={control}
          errors={errors}
          readOnly={disabled}
        />
      </div>

      <div className="mt-3">
        <h4 className="mb-0">
          {t('projectProposal.researchResult.researchContributions.researchGroupDevelopment.label')}
        </h4>
        <p className="font-italic">
          {t('projectProposal.researchResult.researchContributions.researchGroupDevelopment.note')}
        </p>
        <HugerteEditor
          name="researchResult.teamDevelopmentLevel"
          control={control}
          errors={errors}
          readOnly={disabled}
        />
      </div>

      <div className="mt-3">
        <h4 className="mb-0">
          {t(
            'projectProposal.researchResult.researchContributions.abilityTransferResearchResults.label'
          )}
        </h4>
        <p className="font-italic">
          {t(
            'projectProposal.researchResult.researchContributions.abilityTransferResearchResults.note'
          )}
        </p>
        <HugerteEditor
          name="researchResult.researchTransferability"
          control={control}
          errors={errors}
          readOnly={disabled}
        />
      </div>
    </div>
  );
}

ResearchContributions.propTypes = {
  control: PropTypes.shape({}).isRequired,
  errors: PropTypes.shape({}).isRequired,
  disabled: PropTypes.bool.isRequired,
  watch: PropTypes.func.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  researchTypes: PropTypes.array.isRequired,
};
